import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

import { ContextMenuItem } from "src/util/classes/contextMenuItem"
import { PropType } from "vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxContextMenu',
  props: {
  contextMenuItems: {
    required: true,
    type: Array as PropType<Array<ContextMenuItem>>,
  },
},
  emits: ["contextSelect"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createBlock(_component_q_menu, {
    "auto-close": "",
    class: "sfx-context-menu",
    fit: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_list, {
        bordered: "",
        separator: false
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.contextMenuItems, (item) => {
            return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
              clickable: "",
              key: item.action,
              disable: item.disable,
              onClick: ($event: any) => (emit('contextSelect', item))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { avatar: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: item.icon,
                      size: "22px"
                    }, null, 8, ["name"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_q_item_section, { class: "text-h5" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.content), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["disable", "onClick"])), [
              [_directive_ripple]
            ])
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})